export default __webpack_public_path__ + "images/119f69d2c4f1fad5030b9a157279b932-healthcare.jpg";